import { Injectable } from "@angular/core";
import { Terminal } from "../terminal.model";
import { User } from "../user.model";
import { Role } from "../enum/role.enum";

@Injectable({
    providedIn: "root",
})
export class TerminalAdapter {

    /**
     * Permet d'adapter les données d'une DTO à un terminal
     * @param item DTO
     * @returns Terminal
     */
    public adapt(item: any): Terminal {
        return new Terminal(
            item.id,
            item.serialNumber,
            item.identifier,
            item.contractStartedAt,
            item.contractDurationMonths,
            item.contractType,
            item.implantedAt,
            item.storeChain,
            item.isAvailable ?? null,
            item.isCartridgeStuck ?? false,
            item.isBoxFull ?? false,
            item.paperLvl ?? null,
            item.hasPrerequisites ?? false,
            item.lastStatusUpdated,
            item.currentYearRank,
            item.createdAt,
            item.commercialId,
            item.commercial ? this.adaptCommercial(item.commercial) : undefined,
            item.user ? this.adaptCommercial(item.user) : undefined // Réutilise la même méthode
        );
    }

    /**
     * Adapte les données du commercial sans dépendance circulaire
     * @param commercial Données commercial de l'API
     * @returns User commercial
     */
    private adaptCommercial(commercial: any): User {
        return new User(
            commercial.id,
            commercial.lastname,
            commercial.firstname,
            commercial.email,
            this.mapStringToRole(commercial.role),
            false, // linkedWithTerminal
            false, // isLoggedIn
            commercial.createdAt,
            [] // terminals vides pour éviter la circularité
        );
    }

    /**
     * Convertit une string en enum Role
     * @param roleString String du rôle
     * @returns Enum Role
     */
    private mapStringToRole(roleString: string): Role {
        switch (roleString?.toUpperCase()) {
            case 'ADMIN':
                return Role.ADMIN;
            case 'CLIENT':
                return Role.CLIENT;
            case 'COMMERCIAL':
                return Role.COMMERCIAL;
            default:
                return Role.CLIENT;
        }
    }

    /**
     * Adapte une liste de terminaux
     * @param items Liste de DTOs
     * @returns Liste de terminaux
     */
    public adaptMany(items: any[]): Terminal[] {
        return items ? items.map(item => this.adapt(item)) : [];
    }
}
